<template>
    <v-dialog v-model="dialogOpen" max-width="400">
      <v-card class="tw-pb-2">
        <v-card-title>ยืนยันการลบ</v-card-title>
        <v-card-text class="tw-tracking-normal tw-text-base tw-h-20">
          ต้องการลบเอกสาร <b><u>{{ docIdLabel }}</u></b> หรือไม่?
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" class="tw-tracking-normal" @click="onDelete">ลบ</v-btn>
          <v-btn color="grey darken-1" outlined class="tw-tracking-normal" @click="close">ยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
    name: "confirm-delete-dialog",
    props: {
      isOpen: Boolean,
      docIdLabel: String,
    },
    computed: {
      dialogOpen: {
        get() {
          return this.isOpen;
        },
        set() {
          this.close();
        },
      },
    },
    methods: {
      close() {
        this.$emit("update:isOpen", false);
      },
      onDelete() {
        this.$emit("confirm");
        this.close();
      },
      
    },
  };
  </script>
  